import { ProductsService } from '@/services/products.service';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

type CategoryOption = {
  id: string;
  name: string;
  name_translations?: Record<string, string>;
};

export const useListCategories = ({
  categoryType,
}: {
  categoryType: string;
}) => {
  const { i18n } = useTranslation();
  const lang = (i18n.language || 'pt').split('-')[0];

  const { data: categories, isPending: isLoadingCategories } = useQuery({
    queryKey: ['categories', categoryType],
    queryFn: async () => {
      if (!categoryType) {
        return [];
      }

      return ProductsService.listCategories({
        categoryType,
      }) as Promise<CategoryOption[]>;
    },
    enabled: !!categoryType,
  });

  return {
    categories: (categories || []).map((category) => ({
      label: category.name_translations?.[lang] || category.name,
      value: category.id,
    })),
    isLoadingCategories,
  };
};
